module.exports = {
      id: "gallery-whitebg-usage",
      viewBox: "0 0 90 90",
      url: "/" + "sprite-72169aba3aaebb7b19ede7951c92022d.svg#gallery-whitebg",
      toString: function () {
        return this.url;
      }
    }